import { render, staticRenderFns } from "./TechnologiesWeWork.vue?vue&type=template&id=5643fed1&scoped=true&"
import script from "./TechnologiesWeWork.vue?vue&type=script&lang=js&"
export * from "./TechnologiesWeWork.vue?vue&type=script&lang=js&"
import style0 from "./TechnologiesWeWork.vue?vue&type=style&index=0&id=5643fed1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643fed1",
  null
  
)

export default component.exports